import { openDB } from "../utils/indexedDb";
import api from "../components/api";

export async function saveOptometryOffline(optometryData) {
  console.log("💾 Saving optometry offline", optometryData.patient_unique_id);

  const db = await openDB();

  return new Promise((resolve, reject) => {
    const tx = db.transaction("optometry", "readwrite");
    const store = tx.objectStore("optometry");

    store.add({
      ...optometryData,
      synced: 0,
      created_at: new Date().toISOString(),
    });

    tx.oncomplete = () => {
      console.log("✅ Optometry saved offline");
      resolve();
    };

    tx.onerror = () => {
      console.error("❌ Optometry offline save failed", tx.error);
      reject(tx.error);
    };
  });
}

export async function syncOptometryData() {
  const db = await openDB();

  // ✅ Step 1: Read all records (read-only transaction)
  const records = await new Promise((resolve, reject) => {
    const tx = db.transaction("optometry", "readonly");
    const store = tx.objectStore("optometry");
    const request = store.getAll();

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });

  // ✅ Step 2: Process records outside transaction
  for (const record of records) {
    if (record.synced === 0) {
      try {
        // 🔥 Only post to optometry endpoint
        await api.post("/technician/optometry/", {
          ...record,
          patient_excel_id: record.patient_excel_id,  // ensure this exists
        });

        await api.post("/technician/submit/", {
          excel_patient_id: record.patient_excel_id,
          technician_id: record.technician_id,
          service_id: 5,
        });

        // ✅ Step 3: Open NEW transaction to update record
        await new Promise((resolve, reject) => {
          const tx = db.transaction("optometry", "readwrite");
          const store = tx.objectStore("optometry");

          record.synced = 1;
          store.put(record);

          tx.oncomplete = resolve;
          tx.onerror = () => reject(tx.error);
        });

        console.log("✅ Optometry synced:", record.patient_unique_id);
      } catch (err) {
        console.error("❌ Optometry sync failed", err);
      }
    }
  }
}

export async function getOptometrySyncStats() {
  const db = await openDB();

  return new Promise((resolve) => {
    const tx = db.transaction("optometry", "readonly");
    const store = tx.objectStore("optometry");

    let total = 0;
    let synced = 0;
    let unsynced = 0;

    const request = store.openCursor();

    request.onsuccess = (event) => {
      const cursor = event.target.result;
      if (cursor) {
        total++;
        if (cursor.value.synced === 1) {
          synced++;
        } else {
          unsynced++;
        }
        cursor.continue();
      } else {
        resolve({ total, synced, unsynced });
      }
    };
  });
}